// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import { MdVerified, MdStar, MdSearch, MdInventory, MdLocationOn, MdStore, MdAccessTime } from 'react-icons/md';
// import { FiArrowLeft, FiClock, FiTruck } from 'react-icons/fi';
// import { BsShieldCheck } from 'react-icons/bs';
// import ProductCard from './ProductCard'; 
// import ShareButton from './ShareButton';
// import { useCart } from '../App';

// // API Endpoints
// const PRODUCTS_API = "https://server.havbit.in/api/public/products";
// const CATEGORIES_API = "https://server.havbit.in/api/categories";
// const SUBCATEGORIES_API = "https://server.havbit.in/api/subcategories";
// const PUBLIC_BRANDS_API = "https://server.havbit.in/api/public/brands"; // All brands API

// const RestaurantProductsPage = () => {
//   const { restaurantName } = useParams();
//   const navigate = useNavigate();
//   const {
//     cart,
//     addToCart,
//     updateQty,
//     removeFromCart,
//     wishlist = [],
//     toggleWishlistItem
//   } = useCart();
  
//   const [products, setProducts] = useState([]);
//   const [allCategories, setAllCategories] = useState([]);
//   const [allSubcategories, setAllSubcategories] = useState([]);
//   const [allBrands, setAllBrands] = useState([]); // Store all brands
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
  
//   // Brand state
//   const [vendorBrand, setVendorBrand] = useState(null);
//   const [brandLoading, setBrandLoading] = useState(false);
//   const [brandError, setBrandError] = useState(null);

//   // Get cart quantities
//   const cartQuantities = cart.reduce((acc, item) => {
//     acc[item._id] = item.qty || 1;
//     return acc;
//   }, {});

//   // Check if product is in wishlist
//   const isProductInWishlist = (productId) => {
//     return wishlist.some(item => item._id === productId);
//   };

//   // Fetch all brands data
//   const fetchAllBrands = async () => {
//     try {
//       setBrandLoading(true);
//       const response = await fetch(PUBLIC_BRANDS_API);
      
//       if (!response.ok) {
//         throw new Error(`Failed to fetch brands: ${response.status}`);
//       }
      
//       const result = await response.json();
      
//       if (result.success && result.data) {
//         setAllBrands(result.data);
//         return result.data;
//       }
//       return [];
//     } catch (error) {
//       console.error("Error fetching brands:", error);
//       setBrandError(error.message);
//       return [];
//     } finally {
//       setBrandLoading(false);
//     }
//   };

//   // Find brand by restaurantName (brandName match) or by vendor ID
//   const findBrandForRestaurant = async (targetName) => {
//     // First, fetch all brands
//     const brands = await fetchAllBrands();
    
//     // Clean the target name
//     const cleanTargetName = targetName.trim().toLowerCase();
    
//     // Try to find brand by brandName (exact match first, then contains)
//     let foundBrand = brands.find(brand => 
//       brand.brandName && brand.brandName.trim().toLowerCase() === cleanTargetName
//     );
    
//     // If not found by exact brandName, try by vendor name
//     if (!foundBrand) {
//       foundBrand = brands.find(brand => 
//         brand.vendor?.name && brand.vendor.name.trim().toLowerCase() === cleanTargetName
//       );
//     }
    
//     // If still not found, try partial match
//     if (!foundBrand) {
//       foundBrand = brands.find(brand => 
//         brand.brandName && brand.brandName.toLowerCase().includes(cleanTargetName)
//       );
//     }
    
//     return foundBrand;
//   };

//   // API se Data Fetch karna
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
        
//         const targetName = decodeURIComponent(restaurantName);
//         console.log("Looking for restaurant/brand:", targetName);
        
//         // Pehle sabhi brands fetch karein
//         const brands = await fetchAllBrands();
        
//         // Find brand for this restaurant
//         let matchedBrand = null;
//         const cleanTargetName = targetName.trim().toLowerCase();
        
//         // Multiple ways to find matching brand:
//         // 1. Exact match with brandName
//         matchedBrand = brands.find(brand => 
//           brand.brandName && brand.brandName.trim().toLowerCase() === cleanTargetName
//         );
        
//         // 2. Vendor name match
//         if (!matchedBrand) {
//           matchedBrand = brands.find(brand => 
//             brand.vendor?.name && brand.vendor.name.trim().toLowerCase() === cleanTargetName
//           );
//         }
        
//         // 3. Contains match
//         if (!matchedBrand) {
//           matchedBrand = brands.find(brand => 
//             brand.brandName && brand.brandName.toLowerCase().includes(cleanTargetName)
//           );
//         }
        
//         // Set vendor brand data
//         if (matchedBrand) {
//           console.log("Found brand:", matchedBrand.brandName);
//           setVendorBrand({
//             brandName: matchedBrand.brandName,
//             logo: matchedBrand.logo || {
//               url: `https://ui-avatars.com/api/?name=${encodeURIComponent(matchedBrand.brandName)}&background=linear-gradient(45deg,#f59e0b,#ef4444)&color=fff&size=256&bold=true`
//             },
//             banner: matchedBrand.banner || {
//               url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80"
//             },
//             vendor: matchedBrand.vendor || {
//               name: matchedBrand.brandName,
//               verified: false
//             },
//             stats: {
//               rating: 4.5,
//               productsCount: 0
//             }
//           });
//         } else {
//           console.log("No brand found, using fallback for:", targetName);
//           // Fallback brand
//           setVendorBrand({
//             brandName: targetName,
//             logo: {
//               url: `https://ui-avatars.com/api/?name=${encodeURIComponent(targetName)}&background=linear-gradient(45deg,#f59e0b,#ef4444)&color=fff&size=256&bold=true`
//             },
//             banner: {
//               url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80"
//             },
//             vendor: {
//               name: targetName,
//               verified: false
//             },
//             stats: {
//               rating: 4.0,
//               productsCount: 0
//             }
//           });
//         }
        
//         // Products aur categories fetch karein
//         const [productsRes, categoriesRes, subcategoriesRes] = await Promise.all([
//           fetch(PRODUCTS_API),
//           fetch(CATEGORIES_API),
//           fetch(SUBCATEGORIES_API)
//         ]);

//         if (!productsRes.ok) throw new Error("Failed to fetch products");
//         if (!categoriesRes.ok) throw new Error("Failed to fetch categories");
//         if (!subcategoriesRes.ok) throw new Error("Failed to fetch subcategories");

//         const productsResult = await productsRes.json();
//         const categoriesData = await categoriesRes.json();
//         const subcategoriesResult = await subcategoriesRes.json();

//         // Handle subcategories response
//         const subcategoriesData = subcategoriesResult.data || [];

//         // Set all categories and subcategories
//         setAllCategories(categoriesData);
//         setAllSubcategories(subcategoriesData);

//         if (productsResult.success) {
//           // Filter products by restaurantName (exact match)
//           const vendorProducts = productsResult.data.filter(p => {
//             const productRestaurant = (p.restaurantName || "").trim().toLowerCase();
//             return productRestaurant === cleanTargetName;
//           });
          
//           console.log(`Found ${vendorProducts.length} products for restaurant: ${targetName}`);
          
//           // Format products
//           const formatted = vendorProducts.map(p => {
//             // Get category name
//             let categoryName = "";
//             const productCategoryId = p.category;
//             const matchedCat = categoriesData.find(cat => cat._id === productCategoryId);
//             if (matchedCat) {
//               categoryName = matchedCat.name;
//             } else {
//               categoryName = p.category || "";
//             }

//             // Get subcategory name
//             let subcategoryName = "";
//             if (p.subcategory) {
//               const subcategoryId = p.subcategory;
//               const matchedSub = subcategoriesData.find(sub => sub._id === subcategoryId);
//               if (matchedSub && matchedSub.name) {
//                 subcategoryName = matchedSub.name;
//               } else if (typeof p.subcategory === 'string') {
//                 subcategoryName = p.subcategory;
//               }
//             }

//             const price = p.price || 0;
//             const originalPrice = p.oldPrice || 0;
//             let discount = 0;
            
//             if (originalPrice > 0 && price > 0 && originalPrice > price) {
//               discount = Math.round(((originalPrice - price) / originalPrice) * 100);
//             }

//             // Image URL handle karein
//             let imageUrl = p.image;
//             if (!imageUrl && p.gallery && p.gallery.length > 0) {
//               imageUrl = p.gallery[0];
//             }
//             if (!imageUrl) {
//               imageUrl = "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400";
//             }

//             return {
//               id: p.id || p._id,
//               name: p.name || "Product",
//               price: price,
//               originalPrice: originalPrice,
//               discount: discount,
//               image: imageUrl,
//               category: categoryName,
//               subcategory: subcategoryName,
//               categoryId: p.category,
//               subcategoryId: p.subcategory,
//               stock: p.stock || 0,
//               rating: p.rating || 4.3,
//               reviewCount: p.reviewCount || Math.floor(Math.random() * 100) + 10,
//               weight: p.customWeight || p.size || "100g",
//               description: p.description || "",
//               restaurantName: p.restaurantName || "",
//               vendor: p.vendor,
//               vendorBrandName: p.brandName || p.restaurantName || "",
//               quality: p.quality || "Standard",
//               brandName: p.brandName || "",
//               logo: p.logo || "",
//               banner: p.banner || "",
//               source: p.vendor ? "vendor" : "admin",
//               createdAt: p.createdAt || new Date().toISOString()
//             };
//           });

//           setProducts(formatted);
//           setFilteredProducts(formatted);
          
//           // Update brand stats with product count
//           if (formatted.length > 0) {
//             setVendorBrand(prev => ({
//               ...prev,
//               stats: {
//                 ...prev.stats,
//                 productsCount: formatted.length,
//                 rating: formatted.length > 0 
//                   ? formatted.reduce((acc, p) => acc + p.rating, 0) / formatted.length
//                   : 4.5
//               }
//             }));
//           }
//         }
//       } catch (err) { 
//         console.error("Error fetching data:", err); 
//       } finally { 
//         setLoading(false); 
//       }
//     };
//     fetchData();
//   }, [restaurantName]);

//   // Search functionality
//   useEffect(() => {
//     const result = products.filter(p => 
//       p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (p.description || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (p.category || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (p.brandName || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (p.subcategory || "").toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     setFilteredProducts(result);
//   }, [searchQuery, products]);

//   // Cart related functions
//   const handleAddToCart = (product, quantity = 1) => {
//     const cartItem = { 
//       _id: product.id, 
//       name: product.name, 
//       price: product.price, 
//       image: product.image, 
//       qty: quantity,
//       restaurantName: vendorBrand?.brandName || decodeURIComponent(restaurantName)
//     };
//     addToCart(cartItem, quantity);
//   };

//   const handleQuantityUpdate = (productId, change) => {
//     const currentQty = cartQuantities[productId] || 0;
//     const newQty = currentQty + change;
//     newQty < 1 ? removeFromCart(productId) : updateQty(productId, newQty);
//   };

//   const handleToggleWishlist = (product) => {
//     toggleWishlistItem({ 
//       _id: product.id, 
//       name: product.name,
//       price: product.price,
//       image: product.image,
//       originalPrice: product.originalPrice,
//       category: product.category,
//       discount: product.discount,
//       restaurantName: vendorBrand?.brandName || decodeURIComponent(restaurantName)
//     });
//   };

//   if (loading) return (
//     <div className="min-h-screen flex items-center justify-center bg-white">
//       <div className="flex flex-col items-center gap-4">
//         <div className="w-16 h-16 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
//         <p className="text-sm font-medium text-gray-600">Loading {decodeURIComponent(restaurantName)}...</p>
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-[#FAFAFA] text-[#1A1A1A]">
      
//       {/* 1. TOP NAVIGATION & BANNER */}
//       <div className="relative">
//         <button 
//           onClick={() => navigate(-1)}
//           className="absolute top-4 left-4 z-30 p-3 bg-white/90 backdrop-blur-md rounded-full shadow-xl hover:bg-white transition-all"
//         >
//           <FiArrowLeft className="text-lg" />
//         </button>
        
//         {/* Banner with overlay */}
//         <div className="w-full h-48 md:h-72 lg:h-80 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 overflow-hidden relative">
//           {vendorBrand?.banner?.url ? (
//             <img 
//               src={vendorBrand.banner.url} 
//               alt={`${vendorBrand.brandName} Banner`}
//               className="w-full h-full object-cover"
//               onError={(e) => {
//                 e.target.src = "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80";
//               }}
//             />
//           ) : (
//             <div className="w-full h-full bg-gradient-to-br from-red-500 via-orange-500 to-yellow-500 animate-pulse"></div>
//           )}
//           <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
          
//         </div>
//       </div>

//       {/* 2. VENDOR PROFILE CARD */}
//       <header className="px-4 py-6 max-w-7xl mx-auto -mt-16 relative z-20">
//         <div className="flex flex-col md:flex-row items-start md:items-end gap-6">
//           {/* Logo Card */}
//           <div className="bg-white rounded-3xl  shadow-2xl border border-gray-100">
//             <div className="w-28 h-28 md:w-36 md:h-36 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl overflow-hidden p-1">
//               {vendorBrand?.logo?.url ? (
//                 <img 
//                   src={vendorBrand.logo.url} 
//                   alt={`${vendorBrand.brandName} Logo`}
//                   className="w-full h-full object-cover rounded-xl"
//                   onError={(e) => {
//                     e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(vendorBrand.brandName)}&background=linear-gradient(45deg,#f59e0b,#ef4444)&color=fff&size=256&bold=true`;
//                   }}
//                 />
//               ) : (
//                 <div className="w-full h-full bg-gradient-to-br from-red-500 to-orange-500 rounded-xl flex items-center justify-center text-white text-4xl font-black italic">
//                   {(vendorBrand?.brandName || decodeURIComponent(restaurantName)).charAt(0).toUpperCase()}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Vendor Details Card */}
//           <div className="flex-1 bg-white rounded-3xl p-6 shadow-xl border border-gray-100">
//             <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
//               {/* Left: Brand Info */}
//               <div className="flex-1">
//                 <div className="flex items-center gap-3 mb-2">
//                   <h1 className="text-2xl md:text-3xl font-black text-gray-900 uppercase tracking-tight italic">
//                     {vendorBrand?.brandName || decodeURIComponent(restaurantName)}
//                   </h1>
//                   {vendorBrand?.vendor?.verified && (
//                     <MdVerified className="text-blue-500 text-2xl shrink-0" />
//                   )}
//                   <span className="ml-2 px-3 py-1 bg-green-100 text-green-800 text-xs font-bold rounded-full">
//                     Official Store
//                   </span>
//                 </div>
                
//                 {/* Stats Row */}
//                 <div className="flex flex-wrap items-center gap-4 mt-4">
//                   <div className="flex items-center gap-2">
//                     <MdInventory className="text-gray-500" />
//                     <span className="text-sm font-bold text-gray-700">
//                       {vendorBrand?.stats?.productsCount || products.length} Products
//                     </span>
//                   </div>
//                   <div className="flex items-center gap-2">
//                     <MdStar className="text-amber-500" />
//                     <span className="text-sm font-bold text-gray-700">
//                       {vendorBrand?.stats?.rating?.toFixed(1) || '4.8'} Rating
//                     </span>
//                   </div>
//                   <div className="flex items-center gap-2">
//                     <MdLocationOn className="text-red-500" />
//                     <span className="text-sm font-bold text-gray-700">
//                       PAN India
//                     </span>
//                   </div>
//                 </div>
                
//                 {/* Vendor Info */}
//                 <div className="mt-4 flex items-center gap-3">
//                   {vendorBrand?.vendor?.verified && (
//                     <>
//                       <BsShieldCheck className="text-green-500" title="Verified Seller" />
//                       <span className="text-sm text-gray-600">
//                         Verified Seller • {vendorBrand.vendor.name}
//                       </span>
//                     </>
//                   )}
//                 </div>
//               </div>

//               {/* Right: Share Button */}
//               <div className="shrink-0">
//                 <ShareButton 
//                   product={{
//                     _id: restaurantName,
//                     name: `${vendorBrand?.brandName || decodeURIComponent(restaurantName)} Store`,
//                     price: null,
//                     originalPrice: null,
//                     image: vendorBrand?.logo?.url,
//                     description: `Shop from ${vendorBrand?.brandName || decodeURIComponent(restaurantName)} - Premium quality products`
//                   }}
//                   className="transform hover:scale-105 transition-transform"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>


//       {/* 4. PRODUCT GRID */}
//       <main className="px-4 mt-8 max-w-7xl mx-auto pb-24">
//         {/* Products Count */}
//         <div className="flex justify-between items-center mb-6">
//           <h2 className="text-lg font-bold text-gray-900">
//             All Products ({filteredProducts.length})
//           </h2>
//           <div className="text-sm text-gray-500">
//             Sorted by: <span className="font-bold text-gray-700">Popular</span>
//           </div>
//         </div>
        
//         {filteredProducts.length > 0 ? (
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
//             <AnimatePresence mode='popLayout'>
//               {filteredProducts.map((p) => (
//                 <motion.div
//                   key={p.id}
//                   layout
//                   initial={{ opacity: 0, scale: 0.95 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   exit={{ opacity: 0, scale: 0.9 }}
//                   transition={{ duration: 0.3 }}
//                   whileHover={{ y: -5 }}
//                 >
//                   <ProductCard 
//                     product={p}
//                     onAddToCart={handleAddToCart}
//                     onToggleWishlist={handleToggleWishlist}
//                     onQuantityUpdate={handleQuantityUpdate}
//                     isWishlisted={isProductInWishlist(p.id)}
//                     cartQuantity={cartQuantities[p.id] || 0}
//                     navigate={navigate}
//                     restaurantName={vendorBrand?.brandName || decodeURIComponent(restaurantName)}
//                   />
//                 </motion.div>
//               ))}
//             </AnimatePresence>
//           </div>
//         ) : (
//           <div className="text-center py-20 bg-white rounded-3xl mt-4 border-2 border-dashed border-gray-200">
//             <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
//               <MdInventory className="text-4xl text-gray-300" />
//             </div>
//             <h3 className="text-xl font-bold text-gray-800 mb-2">
//               No Products Found
//             </h3>
//             <p className="text-gray-600 max-w-md mx-auto mb-6">
//               {searchQuery 
//                 ? `No products found for "${searchQuery}" in ${vendorBrand?.brandName || decodeURIComponent(restaurantName)}`
//                 : `${vendorBrand?.brandName || decodeURIComponent(restaurantName)} hasn't added any products yet.`
//               }
//             </p>
//             {searchQuery && (
//               <button 
//                 onClick={() => setSearchQuery("")}
//                 className="px-6 py-3 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 transition-colors"
//               >
//                 Clear Search
//               </button>
//             )}
//             <button 
//               onClick={() => navigate('/')}
//               className="ml-4 px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-xl hover:bg-gray-200 transition-colors"
//             >
//               Browse Other Stores
//             </button>
//           </div>
//         )}
//       </main>
//     </div>
//   );
// };

// export default RestaurantProductsPage;





























import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MdVerified, MdStar, MdSearch, MdInventory, MdLocationOn, MdStore, MdAccessTime } from 'react-icons/md';
import { FiArrowLeft, FiClock, FiTruck } from 'react-icons/fi';
import { BsShieldCheck } from 'react-icons/bs';
import ProductCard from './ProductCard'; 
import ShareButton from './ShareButton';
import { useCart } from '../App';

// API Endpoints
const PRODUCTS_API = "https://server.havbit.in/api/public/products";
const CATEGORIES_API = "https://server.havbit.in/api/categories";
const SUBCATEGORIES_API = "https://server.havbit.in/api/subcategories";
const PUBLIC_BRANDS_API = "https://server.havbit.in/api/public/brands";
const BLOGS_API = "https://server.havbit.in/api/blogs/public/all";

const RestaurantProductsPage = () => {
  const { restaurantName } = useParams();
  const navigate = useNavigate();
  const {
    cart,
    addToCart,
    updateQty,
    removeFromCart,
    wishlist = [],
    toggleWishlistItem
  } = useCart();
  
  const [products, setProducts] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allSubcategories, setAllSubcategories] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [storeBlogs, setStoreBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  
  const [vendorBrand, setVendorBrand] = useState(null);
  const [brandLoading, setBrandLoading] = useState(false);
  const [brandError, setBrandError] = useState(null);

  const cartQuantities = cart.reduce((acc, item) => {
    acc[item._id] = item.qty || 1;
    return acc;
  }, {});

  const isProductInWishlist = (productId) => {
    return wishlist.some(item => item._id === productId);
  };

  const fetchAllBrands = async () => {
    try {
      setBrandLoading(true);
      const response = await fetch(PUBLIC_BRANDS_API);
      if (!response.ok) throw new Error(`Failed to fetch brands: ${response.status}`);
      const result = await response.json();
      if (result.success && result.data) {
        setAllBrands(result.data);
        return result.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching brands:", error);
      setBrandError(error.message);
      return [];
    } finally {
      setBrandLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const targetName = decodeURIComponent(restaurantName);
        const cleanTargetName = targetName.trim().toLowerCase();

        // ✅ Step 1: Brands fetch karo
        const brands = await fetchAllBrands();

        // ✅ Step 2: Brand dhundo by brandName (e.g. "karan")
        let matchedBrand = brands.find(brand =>
          brand.brandName && brand.brandName.trim().toLowerCase() === cleanTargetName
        );
        if (!matchedBrand) {
          matchedBrand = brands.find(brand =>
            brand.vendor?.name && brand.vendor.name.trim().toLowerCase() === cleanTargetName
          );
        }
        if (!matchedBrand) {
          matchedBrand = brands.find(brand =>
            brand.brandName && brand.brandName.toLowerCase().includes(cleanTargetName)
          );
        }

        // ✅ Step 3: Saare possible names collect karo match ke liye
        // e.g. namesToMatch = ["karan", "rinku"] 
        const namesToMatch = new Set();
        namesToMatch.add(cleanTargetName); // "karan"
        if (matchedBrand) {
          if (matchedBrand.vendor?.name) {
            namesToMatch.add(matchedBrand.vendor.name.trim().toLowerCase()); // "rinku"
          }
          if (matchedBrand.vendor?.fullBusinessName) {
            namesToMatch.add(matchedBrand.vendor.fullBusinessName.trim().toLowerCase());
          }
          if (matchedBrand.brandName) {
            namesToMatch.add(matchedBrand.brandName.trim().toLowerCase());
          }
        }

        console.log("Names to match:", [...namesToMatch]);

        // Set vendor brand data
        if (matchedBrand) {
          setVendorBrand({
            brandName: matchedBrand.brandName,
            logo: matchedBrand.logo || {
              url: `https://ui-avatars.com/api/?name=${encodeURIComponent(matchedBrand.brandName)}&background=linear-gradient(45deg,#f59e0b,#ef4444)&color=fff&size=256&bold=true`
            },
            banner: matchedBrand.banner || {
              url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80"
            },
            vendor: matchedBrand.vendor || { name: matchedBrand.brandName, verified: false },
            stats: { rating: 4.5, productsCount: 0 }
          });
        } else {
          setVendorBrand({
            brandName: targetName,
            logo: {
              url: `https://ui-avatars.com/api/?name=${encodeURIComponent(targetName)}&background=linear-gradient(45deg,#f59e0b,#ef4444)&color=fff&size=256&bold=true`
            },
            banner: {
              url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80"
            },
            vendor: { name: targetName, verified: false },
            stats: { rating: 4.0, productsCount: 0 }
          });
        }

        const blogsRes = await fetch(BLOGS_API);
        let matchingBlogs = [];
        if (blogsRes.ok) {
          const blogsResult = await blogsRes.json();
          const allPublicBlogs = blogsResult.blogs || [];

          matchingBlogs = allPublicBlogs.filter((blog) => {
            const blogVendorId = blog.vendorId && typeof blog.vendorId === 'object' ? blog.vendorId._id : blog.vendorId;
            const blogVendorName = (blog.vendorId?.name || "").trim().toLowerCase();
            const blogBrandName = (blog.vendorId?.brandName || "").trim().toLowerCase();

            if (matchedBrand?.vendor?._id && blogVendorId) {
              return String(blogVendorId) === String(matchedBrand.vendor._id);
            }

            return [...namesToMatch].some((name) => {
              if (!name) return false;
              return (
                blogVendorName === name ||
                blogBrandName === name ||
                (blogVendorName && blogVendorName.includes(name)) ||
                (blogBrandName && blogBrandName.includes(name))
              );
            });
          });
        }

        setStoreBlogs(matchingBlogs);

        // ✅ Step 4: Products + Categories fetch karo
        const [productsRes, categoriesRes, subcategoriesRes] = await Promise.all([
          fetch(PRODUCTS_API),
          fetch(CATEGORIES_API),
          fetch(SUBCATEGORIES_API)
        ]);

        if (!productsRes.ok) throw new Error("Failed to fetch products");

        const productsResult = await productsRes.json();
        const categoriesData = categoriesRes.ok ? await categoriesRes.json() : [];
        const subcategoriesResult = subcategoriesRes.ok ? await subcategoriesRes.json() : { data: [] };
        const subcategoriesData = subcategoriesResult.data || [];

        setAllCategories(categoriesData);
        setAllSubcategories(subcategoriesData);

        if (productsResult.success) {
          // ✅ KEY FIX: restaurantName, brandName, vendorName — teen jagah se match karo
          const vendorProducts = productsResult.data.filter(p => {
            const pRestaurant = (p.restaurantName || "").trim().toLowerCase();
            const pBrand = (p.brandName || "").trim().toLowerCase();
            const pVendor = (p.vendorName || "").trim().toLowerCase();
            return (
              namesToMatch.has(pRestaurant) ||
              namesToMatch.has(pBrand) ||
              namesToMatch.has(pVendor)
            );
          });

          console.log(`Found ${vendorProducts.length} products`);

          const formatted = vendorProducts.map(p => {
            let categoryName = "";
            const matchedCat = categoriesData.find(cat => cat._id === p.category);
            if (matchedCat) categoryName = matchedCat.name;
            else categoryName = p.category || "";

            let subcategoryName = "";
            if (p.subcategory) {
              const matchedSub = subcategoriesData.find(sub => sub._id === p.subcategory);
              if (matchedSub?.name) subcategoryName = matchedSub.name;
              else if (typeof p.subcategory === 'string') subcategoryName = p.subcategory;
            }

            const price = p.price || 0;
            const originalPrice = p.oldPrice || 0;
            let discount = 0;
            if (originalPrice > 0 && price > 0 && originalPrice > price) {
              discount = Math.round(((originalPrice - price) / originalPrice) * 100);
            }

            let imageUrl = p.image;
            if (!imageUrl && p.gallery?.length > 0) imageUrl = p.gallery[0];
            if (!imageUrl) imageUrl = "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400";

            return {
              id: p.id || p._id,
              slug: p.slug ? p.slug.replace(/-\d{10,}$/, '') : null,
              name: p.name || "Product",
              price,
              originalPrice,
              discount,
              image: imageUrl,
              category: categoryName,
              subcategory: subcategoryName,
              categoryId: p.category,
              subcategoryId: p.subcategory,
              stock: p.stock || 0,
              rating: p.rating || 4.3,
              reviewCount: p.reviewCount || Math.floor(Math.random() * 100) + 10,
              weight: p.customWeight || p.size || "100g",
              description: p.description || "",
              restaurantName: p.restaurantName || "",
              vendor: p.vendor,
              vendorBrandName: p.brandName || p.restaurantName || "",
              quality: p.quality || "Standard",
              brandName: p.brandName || "",
              logo: p.logo || "",
              banner: p.banner || "",
              source: p.vendor ? "vendor" : "admin",
              createdAt: p.createdAt || new Date().toISOString()
            };
          });

          setProducts(formatted);
          setFilteredProducts(formatted);

          if (formatted.length > 0) {
            setVendorBrand(prev => ({
              ...prev,
              stats: {
                productsCount: formatted.length,
                rating: formatted.reduce((acc, p) => acc + p.rating, 0) / formatted.length
              }
            }));
          }
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [restaurantName]);

  // Search
  useEffect(() => {
    const result = products.filter(p =>
      p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (p.description || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (p.category || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (p.brandName || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (p.subcategory || "").toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredProducts(result);
  }, [searchQuery, products]);

  const handleAddToCart = (product, quantity = 1) => {
    const cartItem = {
      _id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      qty: quantity,
      restaurantName: vendorBrand?.brandName || decodeURIComponent(restaurantName)
    };
    addToCart(cartItem, quantity);
  };

  const handleQuantityUpdate = (productId, change) => {
    const currentQty = cartQuantities[productId] || 0;
    const newQty = currentQty + change;
    newQty < 1 ? removeFromCart(productId) : updateQty(productId, newQty);
  };

  const handleToggleWishlist = (product) => {
    toggleWishlistItem({
      _id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      originalPrice: product.originalPrice,
        category: product.category,
      discount: product.discount,
      restaurantName: vendorBrand?.brandName || decodeURIComponent(restaurantName)
    });
  };

  // ✅ Product navigate — slug use karo
  const handleProductNavigate = (product) => {
    const slug = product.slug ||
      (product.name || '').toLowerCase().trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    navigate(`/product/${slug}`);
  };

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-sm font-medium text-gray-600">
          Loading {decodeURIComponent(restaurantName)}...
        </p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-[#1A1A1A]">

      {/* BANNER */}
      <div className="relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-4 z-30 p-3 bg-white/90 backdrop-blur-md rounded-full shadow-xl hover:bg-white transition-all"
        >
          <FiArrowLeft className="text-lg" />
        </button>

        <div className="w-full h-48 md:h-72 lg:h-80 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 overflow-hidden relative">
          {vendorBrand?.banner?.url ? (
            <img
              src={vendorBrand.banner.url}
              alt={`${vendorBrand.brandName} Banner`}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80";
              }}
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-red-500 via-orange-500 to-yellow-500"></div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
        </div>
      </div>

      {/* VENDOR PROFILE CARD */}
      <header className="px-4 py-6 max-w-7xl mx-auto -mt-16 relative z-20">
        <div className="flex flex-col md:flex-row items-start md:items-end gap-6">
          {/* Logo */}
          <div className="bg-white rounded-3xl shadow-2xl border border-gray-100">
            <div className="w-28 h-28 md:w-36 md:h-36 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl overflow-hidden p-1">
              {vendorBrand?.logo?.url ? (
                <img
                  src={vendorBrand.logo.url}
                  alt={`${vendorBrand.brandName} Logo`}
                  className="w-full h-full object-cover rounded-xl"
                  onError={(e) => {
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(vendorBrand.brandName)}&background=linear-gradient(45deg,#f59e0b,#ef4444)&color=fff&size=256&bold=true`;
                  }}
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-red-500 to-orange-500 rounded-xl flex items-center justify-center text-white text-4xl font-black italic">
                  {(vendorBrand?.brandName || decodeURIComponent(restaurantName)).charAt(0).toUpperCase()}
                </div>
              )}
            </div>
          </div>

          {/* Details */}
          <div className="flex-1 bg-white rounded-3xl p-6 shadow-xl border border-gray-100">
            <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h1 className="text-2xl md:text-3xl font-black text-gray-900 uppercase tracking-tight italic">
                    {vendorBrand?.brandName || decodeURIComponent(restaurantName)}
                  </h1>
                  {vendorBrand?.vendor?.verified && (
                    <MdVerified className="text-blue-500 text-2xl shrink-0" />
                  )}
                  <span className="ml-2 px-3 py-1 bg-green-100 text-green-800 text-xs font-bold rounded-full">
                    Official Store
                  </span>
                </div>

                <div className="flex flex-wrap items-center gap-4 mt-4">
                  <div className="flex items-center gap-2">
                    <MdInventory className="text-gray-500" />
                    <span className="text-sm font-bold text-gray-700">
                      {vendorBrand?.stats?.productsCount || products.length} Products
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MdStar className="text-amber-500" />
                    <span className="text-sm font-bold text-gray-700">
                      {vendorBrand?.stats?.rating?.toFixed(1) || '4.8'} Rating
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MdLocationOn className="text-red-500" />
                    <span className="text-sm font-bold text-gray-700">PAN India</span>
                  </div>
                </div>

                {vendorBrand?.vendor?.verified && (
                  <div className="mt-4 flex items-center gap-3">
                    <BsShieldCheck className="text-green-500" title="Verified Seller" />
                    <span className="text-sm text-gray-600">
                      Verified Seller • {vendorBrand.vendor.name}
                    </span>
                  </div>
                )}
              </div>

              <div className="shrink-0">
                <ShareButton
                  product={{
                    _id: restaurantName,
                    name: `${vendorBrand?.brandName || decodeURIComponent(restaurantName)} Store`,
                    price: null,
                    originalPrice: null,
                    image: vendorBrand?.logo?.url,
                    description: `Shop from ${vendorBrand?.brandName || decodeURIComponent(restaurantName)}`
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </header>

      {storeBlogs.length > 0 && (
        <section className="px-4 mt-8 max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-gray-900">
              Latest from {vendorBrand?.brandName || decodeURIComponent(restaurantName)}
            </h2>
            <button
              onClick={() => navigate('/blogs')}
              className="text-sm font-semibold text-red-600 hover:text-red-700"
            >
              View all blogs
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {storeBlogs.slice(0, 3).map((blog) => (
              <article key={blog._id} className="bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                {blog.media && (
                  <div className="h-48 overflow-hidden bg-gray-100 relative">
                    {blog.mediaType === 'video' ? (
                      <>
                        <video
                          src={blog.media}
                          preload="metadata"
                          muted
                          playsInline
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-black/10">
                          <div className="w-11 h-11 rounded-full bg-white/90 flex items-center justify-center shadow-md">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                              <path d="M8 5v14l11-7-11-7Z" fill="#111827" />
                            </svg>
                          </div>
                        </div>
                      </>
                    ) : (
                      <img
                        src={blog.media}
                        alt={blog.title}
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>
                )}
                <div className="p-4">
                  <p className="text-[10px] uppercase tracking-[0.12em] font-bold text-red-500 mb-2">
                    {blog.mediaType === 'video' ? 'Video' : 'Story'}
                  </p>
                  <h3 className="text-base font-bold text-gray-900 mb-2 line-clamp-2">{blog.title}</h3>
                  <p className="text-sm text-gray-600 line-clamp-3">{blog.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* PRODUCT GRID */}
      <main className="px-4 mt-8 max-w-7xl mx-auto pb-24">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-bold text-gray-900">
            All Products ({filteredProducts.length})
          </h2>
          <div className="text-sm text-gray-500">
            Sorted by: <span className="font-bold text-gray-700">Popular</span>
          </div>
        </div>

        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
            <AnimatePresence mode='popLayout'>
              {filteredProducts.map((p) => (
                <motion.div
                  key={p.id}
                  layout
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.3 }}
                  whileHover={{ y: -5 }}
                >
                  <ProductCard
                    product={p}
                    onAddToCart={handleAddToCart}
                    onToggleWishlist={handleToggleWishlist}
                    onQuantityUpdate={handleQuantityUpdate}
                    isWishlisted={isProductInWishlist(p.id)}
                    cartQuantity={cartQuantities[p.id] || 0}
                    navigate={navigate}
                    restaurantName={vendorBrand?.brandName || decodeURIComponent(restaurantName)}
                  />
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        ) : (
          <div className="text-center py-20 bg-white rounded-3xl mt-4 border-2 border-dashed border-gray-200">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <MdInventory className="text-4xl text-gray-300" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">No Products Found</h3>
            <p className="text-gray-600 max-w-md mx-auto mb-6">
              {searchQuery
                ? `No products found for "${searchQuery}"`
                : `${vendorBrand?.brandName || decodeURIComponent(restaurantName)} hasn't added any products yet.`
              }
            </p>
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="px-6 py-3 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 transition-colors"
              >
                Clear Search
              </button>
            )}
            <button
              onClick={() => navigate('/')}
              className="ml-4 px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-xl hover:bg-gray-200 transition-colors"
            >
              Browse Other Stores
            </button>
          </div>
        )}
      </main>
    </div>
  );
};

export default RestaurantProductsPage;